export default __webpack_public_path__ + "static/AntIcon168-0b63ac385585bf35c1679729d9d71181.png";